<div aria-hidden="true" class="spinner-container bg-white-100" *ngIf="showSpinner">
    <app-spinner></app-spinner>
</div>
<router-outlet></router-outlet>